import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Common
import { RemoveIcon } from '$common/icons/remove'
import { PermissionsIcon } from '$common/icons/permissions'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
// Logic
import { resetMemberPermissions } from '$logic/subscription'
import { removeFromOpenedUserList } from '$logic/opened-user-list'
import { openEditGroupMemberPermissionsOverride } from '$logic/router'
import { t } from '$i18n'

interface Props {
  isOpen: boolean
  roomId: string
  userId: string
}

export function GroupExceptionUserMenu({ userId, roomId, isOpen }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.hall.editRights')}
        onClick={async () => {
          await closeCurrentModal()
          openEditGroupMemberPermissionsOverride(roomId, userId)
        }}
      >
        <PermissionsIcon />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.removedUser.delete')}
        onClick={async () => {
          await resetMemberPermissions(roomId, userId)
          removeFromOpenedUserList(userId)
          await closeCurrentModal()
        }}
      >
        <RemoveIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
